import React from "react";
import FailedPaymentIcon from "icons/dashboard/FailedPaymentIcon";
import { EyeIcon } from "icons/payments/EyeIcon";
import { CloseIcon } from "icons/payments/CloseIcon";
import { useTid } from "utils/testid";

interface FailedPaymentHeaderProps {
  onPreviewClick: () => void;
  onClose: () => void;
}

const FailedPaymentHeader: React.FC<FailedPaymentHeaderProps> = ({
  onPreviewClick,
  onClose,
}) => {
  const tid = useTid();

  return (
    <div
      className="flex items-center justify-between w-full pb-5 lg:px-0 px-5"
      data-testid={tid("failed-payment-header")}
    >
      <div className="flex items-center gap-2">
        <FailedPaymentIcon
          aria-hidden="true"
          strokeColor="var(--color-txt-primary)"
          width="24"
          height="24"
        />
        <div className="lg:text-[26px] text-lg text-txtPrimary font-medium leading-[30px]">
          Failed Payment Recovery
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div
          role="button"
          tabIndex={0}
          aria-label="Preview failed payment receipt"
          data-testid={tid("failed-payment-preview-button")}
          className="flex items-center gap-1 cursor-pointer p-2 lg:p-0"
          onClick={onPreviewClick}
        >
          <EyeIcon
            aria-hidden="true"
            strokeColor="var(--color-btn-primary-active)"
            width="24"
            height="24"
          />
          {/* Icon-only on phones: the label costs ~69px of a 327px row, which is
              what forced the title to wrap. The control keeps its aria-label, so
              it still announces as "Preview failed payment receipt", and the
              padding above gives the bare icon a 40px touch target. */}
          <p className="hidden lg:block text-lg font-medium text-btnPrimaryActive leading-normal hover:!text-btnPrimaryHover">
            Preview
          </p>
        </div>
        <span
          role="button"
          tabIndex={0}
          aria-label="Close failed payment recovery"
          data-testid={tid("failed-payment-close-button")}
          onClick={onClose}
          className="cursor-pointer p-2 rounded-full hover:!bg-bgSecondary"
        >
          <CloseIcon />
        </span>
      </div>
    </div>
  );
};

export default FailedPaymentHeader;
